import React, { Component } from "react";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import FillBox from "../components/ui-components/FillBox";
import { Box } from "@mui/system";
import "../styles/components.css";
import axios from "axios";
import { getURLBase, updateParentHeight } from "../utils/helperFns";
import { Button, CircularProgress, Divider, Grid } from "@mui/material";
import Add from "@mui/icons-material/Add";
import theme from "../styles/customTheme"

import CreateNewEnvelope from "../components/ui-components/money-tab/CreateNewEnvelope";
import InvestmentsEnvelope from "../components/ui-components/money-tab/InvestmentsEnvelope";
import SavingEnvelope from "../components/ui-components/money-tab/SavingEnvelope";
import { SavingsEnvelopesImages } from "../utils/mockData";

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

const images = SavingsEnvelopesImages;

export class SavingEnvelopes extends Component {
    constructor(props) {
        super(props);
        this.max_saveable = getURLBase(true) + "/sweepaccountdetailsnew";
        this.url = getURLBase(true) + "/envelopes"
        this.state = {
            isReady: false,
            showSavingsEnvelope: false,
            showCreateNewEnvelope: false,
            showInvestmentEnvelope: false,
            open: false,
        }
    }
    componentDidMount() {
        if (!this.state.isReady) {
            axios.post(this.max_saveable, { gid: this.props.gid }).then(
                (res) => {
                    this.setState({
                        max_save: res.data.body.can_save,
                    })
                });
            axios.post(this.url, { gid: this.props.gid }).then(
                (response) => {
                    var investment = response.data.body.envelopes.pop();

                    // sort response.data.body.envelopes by category
                    response.data.body.envelopes.sort((a, b) => {
                        if (a.category < b.category) {
                            return -1;
                        }
                        if (a.category > b.category) {
                            return 1;
                        }
                        return 0;
                    }
                    );
                    console.log("saving envelopes", response.data.body)
                    this.setState(response.data.body)
                    this.setState({ investmentEnv: investment })
                    this.setState({ isReady: true });
                }
            )
        }
    }

    refreshEnvelopes = () => {
        axios.post(this.url, { gid: this.props.gid }).then(
            (response) => {
                var investment = response.data.body.envelopes.pop();
                this.setState(response.data.body)
                this.setState({ investmentEnv: investment })
                this.setState({ isReady: true });
            }
        )
    }


    toggleCreateNewEnvelope = (redirectd = false) => {
        var show = this.state.showCreateNewEnvelope;
        show = !show;
        this.setState({ showCreateNewEnvelope: show },
            () => {
                updateParentHeight("parent_SavingEnvelopes", "child_CreateNewEnvelope", this.state.showCreateNewEnvelope);
                if (redirectd === true) {
                    this.toggleOpen();
                    // toggle open again after 3 seconds
                    setTimeout(() => {
                        this.toggleOpen();
                    }
                        , 6251);

                }
            });
    }

    toggleInvestmentsEnvelopeHandler = () => {
        var show = this.state.showInvestmentEnvelope;
        show = !show;
        this.setState({ showInvestmentEnvelope: show },
            () => {
                updateParentHeight("parent_SavingEnvelopes", "child_InvestmentsEnvelope", this.state.showInvestmentEnvelope);
            });
    }

    toggleSavingsEnvelopeHandler = async (reverse = false) => {
        if (reverse) {
            this.setState({ isReady: false });
            axios.post(this.url, { gid: this.props.gid }).then(
                (response) => {
                    var investment = response.data.body.envelopes.pop();
                    this.setState(response.data.body)

                    this.setState({ investmentEnv: investment })
                    var show = this.state.showSavingsEnvelope;
                    show = !show;
                    this.setState({ showSavingsEnvelope: show },
                        () => {
                            updateParentHeight("parent_SavingEnvelopes", "child_SavingEnvelope", this.state.showSavingsEnvelope);
                        });
                }
            )
            this.setState({ isReady: true });

            return
        }
        this.setState({ isReady: false });
        var show = this.state.showSavingsEnvelope;
        show = !show;
        this.setState({ showSavingsEnvelope: show },
            () => {
                updateParentHeight("parent_SavingEnvelopes", "child_SavingEnvelope", this.state.showSavingsEnvelope);
            });

    }

    toggleOpen = () => {
        this.setState({ open: !this.state.open });
    }
    handleClose = () => {
        this.setState({ open: false });
    };

    render() {

        return (
            <Card className="widgetCard cardShadow" id="parent_SavingEnvelopes">
                <Typography variant="h4" fontWeight={700} align="center" gutterBottom>Saving Envelopes</Typography>
                <Button sx={{
                margin: "0 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginY: "0.6rem",
                marginTop: "-0.4rem",
                // fontSize: "0.7rem",
                padding: "2px"
                }}
                    onClick={() => this.props.setEmbedUrl(this.state.tutorial_iframe)}
                >
                    See how this works <img src="/tutorial-icon.png" style={{ width: "35px", padding: "5px" }} />
                </Button>
                <Divider light />
                {this.state.isReady ?
                    <CardContent>
                        <Grid container justifyContent="center" rowGap={2} columnSpacing={{ xs: 2, sm: 7 }} padding="0 1vw">
                            {this.state.envelopes.map((i, index) =>
                                <Grid key={index} item md={3} sm={4} xs={6} display="flex" className={`${(i.saved === null) ? "blur " : ""}`} >
                                    <Button
                                        onClick={(i.saved === null) ? '' : () => {
                                            var env = i;
                                            env.icon = images[i.icon];
                                            this.setState({ envelopeToOpen: env });
                                            this.toggleSavingsEnvelopeHandler()
                                        }
                                        }
                                        variant="text"
                                        sx={{ width: "100%", padding: 0 }}>
                                        <FillBox category={i.category} saved={i.saved} target={i.target} image={images[i.icon]}
                                        />
                                    </Button>
                                </Grid>
                            )}
                            <Grid item md={3} sm={4} xs={6}>
                                <Button
                                    className="fillBox flex-center-all"
                                    variant="outlined"
                                    color="primary"
                                    onClick={this.toggleCreateNewEnvelope}
                                    sx={{
                                        padding: "2rem 0",
                                        transition: `all ${theme.transitions.duration.standard} ${theme.transitions.easing.easeInOut}`,
                                        textDecoration: "none",
                                        minHeight: "140px",
                                        width: "100%", padding: 0, flexDirection: "column",
                                        backgroundImage: `linear-gradient(180deg, rgba(93, 198, 142, 0.75) 0%, rgba(74, 172, 72, 0.165) 100%);`,
                                        '&:hover': {
                                            backgroundPosition: "200%"
                                            //backgroundColor: purple[700],
                                        }
                                    }}
                                >
                                    <Add color="primary" />
                                    <Typography variant="h6">New Envelope</Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                    : <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "20vh" }}><CircularProgress color="success" /></Box>
                }
                {
                    this.state.showCreateNewEnvelope ?
                        <CreateNewEnvelope
                            gid={this.props.gid}
                            toggleHandler={this.toggleCreateNewEnvelope}
                            toggleOpen={this.toggleOpen}
                            refreshEnvelopes={this.refreshEnvelopes} />
                        : this.state.showInvestmentEnvelope ?
                            <InvestmentsEnvelope
                                envelope={this.state.investmentEnv}
                                toggleHandler={this.toggleInvestmentsEnvelopeHandler} />
                            : this.state.showSavingsEnvelope ?
                                <SavingEnvelope
                                    gid={this.props.gid}
                                    max_save={this?.state?.max_save}
                                    envelope={this.state.envelopeToOpen}
                                    toggleHandler={this.toggleSavingsEnvelopeHandler}
                                    updateParentHeight={() => updateParentHeight("parent_SavingEnvelopes", "child_SavingEnvelope", this.state.showSavingsEnvelope)}
                                />
                                : null
                }
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{ borderRadius: "30px" }}
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" className="font-medium">
                            {/* <div > */}

                            <img src="/success.gif" style={{ display: "block", margin: "auto" }} />
                            <p style={{ marginTop: "-20px", margin: "auto", textAlign: "center", fontWeight: 900 }}>This action will be completed soon. Look out for an email!</p>
                            {/* </div> */}
                        </DialogContentText>
                    </DialogContent>
                </Dialog>

            </Card>
        );
    }
}

export default SavingEnvelopes;
